import styled, { css } from 'styled-components/macro';
import { getTextStyles } from '@yme/utils/styles';
export const MiniButtonStyled = styled.button `
  ${({ bgStyle }) => `background-color: ${bgStyle};`}
  ${({ isInteractive }) => isInteractive && 'cursor: pointer;'}

  ${({ contentColor }) => `color: ${contentColor};`}

  ${({ isPaddingsReset }) => (isPaddingsReset ? 'padding: 0;' : 'padding: 4px 6px 4px 10px;')}

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border: none;
  border-radius: 4px;
  text-decoration: none;

  /* TODO: (D.K.) Need clarify this style */
  /* &:hover {
    background: colorBlackTransparent100;
  } */

  ${({ isUnderlined }) => isUnderlined &&
    css `
      height: auto;
      padding: 0;

      & > span {
        text-decoration: underline;
      }
    `}

  & > span {
    ${({ contentColor }) => `color: ${contentColor};`}
  }

  & > span > svg,
  & > span > svg path {
    ${({ contentColor }) => `fill: ${contentColor};`}
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
export const MiniButtonContent = styled.span `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  ${({ order }) => `order: ${order};`}

  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
`;
